import styled from "styled-components";

export const BookingDetailContainerStyled = styled.div`
  padding-top: 20px;
  .breadcrumb_layout {
    margin-bottom: 30px;
    margin-left: 16px;
  }
  .booking_detail_container {
    margin: auto;
    max-width: ${({ theme }) => theme.ETC.ACTIVITY_DETAIL_WIDTH};
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    padding-top: 0px;
    .breadcrumb_layout {
      display: none;
    }
  }
`;
